import { CounterType } from "definitions/counter-api";
import { DewuLogo, PoizonComLogo } from "src/components/Icons";

export interface CounterTypeInfo {
  name: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export const getCounterTypeInfo = (type: CounterType): CounterTypeInfo => {
  switch (type) {
    case CounterType.PoizonRuRequests:
      return {
        name: "Poizon RU",
        icon: PoizonComLogo,
      };
    case CounterType.PoizonComRequests:
      return {
        name: "Poizon COM",
        icon: PoizonComLogo,
      };
    case CounterType.DewuRequests:
      return {
        name: "Dewu",
        icon: DewuLogo,
      };
    case CounterType.AllSourcesRequests:
      return {
        name: "Все магазины",
        icon: () => null,
      };
    case CounterType.TmallRequests:
      return {
        name: "Tmall",
        icon: () => null, // TODO: добавить иконку Tmall
      };
    case CounterType.ApiRequests:
      return {
        name: "API запросы",
        icon: () => null,
      };
    case CounterType.TranslationSymbols:
      return {
        name: "Символы перевода",
        icon: () => null,
      };
    case CounterType.GptTokens:
      return {
        name: "GPT токены",
        icon: () => null,
      };
    default:
      return {
        name: type,
        icon: () => null,
      };
  }
};
